/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type CreateAgentAssistantMutationVariables = {
    agentId: string;
    assistantMobile: string;
    assistantName?: string | null | undefined;
    pin?: string | null | undefined;
};
export type CreateAgentAssistantMutationResponse = {
    readonly createAgentAssistant: {
        readonly result: string;
        readonly agent: {
            readonly id: string;
            readonly " $fragmentRefs": FragmentRefs<"AgentUsersList_agent">;
        };
    } | null;
};
export type CreateAgentAssistantMutation = {
    readonly response: CreateAgentAssistantMutationResponse;
    readonly variables: CreateAgentAssistantMutationVariables;
};



/*
mutation CreateAgentAssistantMutation(
  $agentId: ID!
  $assistantMobile: String!
  $assistantName: String
  $pin: String
) {
  createAgentAssistant(agentId: $agentId, assistantMobile: $assistantMobile, assistantName: $assistantName, pin: $pin) {
    result
    agent {
      id
      ...AgentUsersList_agent
    }
  }
}

fragment AgentUsersList_agent on Agent {
  principal {
    id
  }
  agentUsers {
    isActive
    canLogin
    user {
      id
      contactMobile
      name
    }
    agentAppVersion {
      appType
      string
      isUpToDate
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "agentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "assistantMobile"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "assistantName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pin"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "agentId",
    "variableName": "agentId"
  },
  {
    "kind": "Variable",
    "name": "assistantMobile",
    "variableName": "assistantMobile"
  },
  {
    "kind": "Variable",
    "name": "assistantName",
    "variableName": "assistantName"
  },
  {
    "kind": "Variable",
    "name": "pin",
    "variableName": "pin"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "result",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateAgentAssistantMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateAgentAssistant",
        "kind": "LinkedField",
        "name": "createAgentAssistant",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Agent",
            "kind": "LinkedField",
            "name": "agent",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AgentUsersList_agent"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateAgentAssistantMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateAgentAssistant",
        "kind": "LinkedField",
        "name": "createAgentAssistant",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Agent",
            "kind": "LinkedField",
            "name": "agent",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "principal",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentUser",
                "kind": "LinkedField",
                "name": "agentUsers",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isActive",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canLogin",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "contactMobile",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AppVersion",
                    "kind": "LinkedField",
                    "name": "agentAppVersion",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "appType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "string",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isUpToDate",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "01f854007eac020aba57ef0fd6c2d6ee",
    "id": null,
    "metadata": {},
    "name": "CreateAgentAssistantMutation",
    "operationKind": "mutation",
    "text": "mutation CreateAgentAssistantMutation(\n  $agentId: ID!\n  $assistantMobile: String!\n  $assistantName: String\n  $pin: String\n) {\n  createAgentAssistant(agentId: $agentId, assistantMobile: $assistantMobile, assistantName: $assistantName, pin: $pin) {\n    result\n    agent {\n      id\n      ...AgentUsersList_agent\n    }\n  }\n}\n\nfragment AgentUsersList_agent on Agent {\n  principal {\n    id\n  }\n  agentUsers {\n    isActive\n    canLogin\n    user {\n      id\n      contactMobile\n      name\n    }\n    agentAppVersion {\n      appType\n      string\n      isUpToDate\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'a07b5c4af1f475d712218a84fd3f7901';
export default node;
